import { ArticleProps } from './schemas/article';
import { BreadcrumbProps } from './schemas/breadcrumb';
import { ItemListProps } from './schemas/itemList';
import { OrganizationProps } from './schemas/organization';
import { ProductProps } from './schemas/product';
import { VideoProps } from './schemas/video';
import { WebSiteProps } from './schemas/website';

export enum SchemaTypes {
    Article = 'Article',
    Breadcrumb = 'Breadcrumb',
    ItemList = 'ItemList',
    Organization = 'Organization',
    Product = 'Product',
    Video = 'Video',
    Website = 'Website',
}

export { AvailabilityTypes } from './availability';

interface Article {
    type: SchemaTypes.Article;
    props: ArticleProps;
}

interface Breadcrumb {
    type: SchemaTypes.Breadcrumb;
    props: BreadcrumbProps;
}

interface ItemList {
    type: SchemaTypes.ItemList;
    props: ItemListProps;
}

interface Organization {
    type: SchemaTypes.Organization;
    props: OrganizationProps;
}

interface Product {
    type: SchemaTypes.Product;
    props: ProductProps;
}

interface Video {
    type: SchemaTypes.Video;
    props: VideoProps;
}

interface WebSite {
    type: SchemaTypes.Website;
    props: WebSiteProps;
}

export type Schemas = Article | Breadcrumb | ItemList | Organization | Product | Video | WebSite; // | OtherSchemas
